import { Injectable } from '@angular/core';

import {
  LogLevel,
  OidcConfigService,
  OidcSecurityService,
  PublicEventsService,
} from 'angular-auth-oidc-client';
import {
  of,
  ReplaySubject,
} from 'rxjs';
import {
  flatMap,
  tap,
} from 'rxjs/operators';

import { environment } from '../../../environments/environment';

export function configureAuth(oidcConfigService: OidcConfigService) {
  return () =>
    oidcConfigService.withConfig({
      stsServer: `https://${environment.aadB2cName}.b2clogin.com/${environment.aadB2cName}.onmicrosoft.com/v2.0`,
      authWellknownEndpoint: `https://${environment.aadB2cName}.b2clogin.com/${environment.aadB2cName}.onmicrosoft.com/B2C_1A_force_reset_signin/v2.0/.well-known/openid-configuration`,
      redirectUrl: window.location.origin,
      triggerAuthorizationResultEvent: true, // evito che mi mandi a /unauthorized subito senza passare dalla guard
      postLogoutRedirectUri: window.location.origin,
      clientId: `${environment.aadClientId}`,
      scope: `openid https://${environment.aadB2cName}.onmicrosoft.com/api/access_as_user`,
      responseType: 'code',
      silentRenew: true,
      maxIdTokenIatOffsetAllowedInSeconds: 600,
      issValidationOff: false, // this needs to be true if using a common endpoint in Azure
      autoUserinfo: false,
      tokenRefreshInSeconds: 60,
      renewTimeBeforeTokenExpiresInSeconds: 2700, // Refresh dopo 15 minuti (45 pre-scadenza) per evitare che scada la session adb2c
      silentRenewUrl: window.location.origin + '/silent-renew.html',
      logLevel: LogLevel.Debug,
      storage: sessionStorage,
    });
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private checkAuthCompleted$ = new ReplaySubject<void>(1);

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private eventService: PublicEventsService
  ) {
    this.signedIn.subscribe((r) => {
      // console.log('signedin ', r);
    });

    // this.eventService
    //     .registerForEvents()
    //     .pipe(filter((notification) => notification.type === EventTypes.NewAuthorizationResult))
    //     .subscribe((value) => {
    //         console.log('AuthorizationResult with value ', value);
    //     });
  }

  get signedIn() {
    return this.checkAuthCompleted$.pipe(
      flatMap((r) => this.oidcSecurityService.isAuthenticated$)
    );
  }

  get token() {
    return this.oidcSecurityService.getToken();
  }

  get userData() {
    return this.oidcSecurityService.userData$;
  }

  checkAuth() {
    return this.oidcSecurityService.checkAuthIncludingServer().pipe(
      // debounceTime(500),
      tap((r) => this.checkAuthCompleted$.next())
    );
  }

  login() {
    return of(this.oidcSecurityService.authorize());
  }

  logout() {
    this.oidcSecurityService.logoffAndRevokeTokens();
  }

  logoutLocal() {
    this.oidcSecurityService.logoffLocal();
  }

  refresh() {
    return this.oidcSecurityService.forceRefreshSession();
  }

  forgotPassword() {
    const resetUrl =
      `https://${environment.aadB2cName}.b2clogin.com/${environment.aadB2cName}.onmicrosoft.com/oauth2/v2.0/authorize?` +
      'p=B2C_1_ChangePassword' +
      `&client_id=${environment.aadClientId}` +
      '&nonce=defaultNonce' +
      '&redirect_uri=' +
      window.location.origin +
      '%2Flogin' +
      '&scope=openid' +
      '&response_type=code' +
      '&prompt=login' +
      '&code_challenge=YTFjNjI1OWYzMzA3MTI4ZDY2Njg5M2RkNmVjNDE5YmEyZGRhOGYyM2IzNjdmZWFhMTQ1ODg3NDcxY2Nl&code_challenge_method=S256';

    const redir = resetUrl;
    window.location.href = redir;
  }
}
